/**
 * Checks if the current execution context has Window object available.
 * This is needed in SSR contexts since we can't call any browser APIs under
 * window/global directly.
 *
 * @returns `true` if the window can be used
 */
export function hasWindow() {
    return typeof window === 'object';
}
